"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arabToAlphabetic = void 0;
/**
 * maps an integer to the alphabet based numbering
 *   0  => a
 *   1  => b
 *   26 => aa
 *   27 => ab
 */
function arabToAlphabetic(n) {
    const charCodeA = 'a'.charCodeAt(0);
    const charCodeZ = 'z'.charCodeAt(0);
    const len = charCodeZ - charCodeA + 1;
    let s = '';
    while (n >= 0) {
        s = String.fromCharCode((n % len) + charCodeA) + s;
        n = Math.floor(n / len) - 1;
    }
    return s;
}
exports.arabToAlphabetic = arabToAlphabetic;
//# sourceMappingURL=alphabetic.js.map